<template>
  <div class="queue-navigation">
    <div class="">
      <div class="field has-addons">
        <p class="control">
          <router-link class="is-small button is-darkmode-dark" :to="{ name: 'Summoner' }" exact-active-class="is-primary is-selected">SOLO</router-link>
        </p>
        <p class="control">
          <router-link class="is-small button is-darkmode-dark" :to="{ name: 'SummonerFlex' }" exact-active-class="is-primary is-selected">FLEX</router-link>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  props: {},

  data () {
    return {}
  },

  computed: {},

  methods: {},
}
</script>

<style scoped>
.queue-navigation {
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
}

.is-dark .is-darkmode-dark:not(.is-selected) {
  background-color: #1e2226;
  border-color: #1e2226;
  color: whitesmoke;
}
</style>



// WEBPACK FOOTER //
// QueueSwitcher.vue?2dc7f0b3